import { defineGameCard, onResolve } from '../authoring/index.js';
import { plannedUnit } from './helpers.js';
export const RecyclingCard = defineGameCard({
    id: 'recycling',
    gameplay: {
        type: 'SPELL', cost: 2,
        planning: {
            target: 'unit', unitFilter: 'ally',
            validatePlan(state, playerId, plan) {
                const target = plan.targetInstanceId === undefined ? undefined : state.instances[plan.targetInstanceId];
                return target !== undefined
                    && (target.controllerId ?? target.ownerId) === playerId
                    && target.zone === 'board'
                    && target.cellId !== undefined
                    && target.isToken === true;
            },
        },
    },
    presentation: {
        name: 'Утилизация',
        description: 'Уничтожьте выбранный союзный токен. Возьмите 2 карты.',
        glyph: {
            colors: ['#10213A', '#C6D7D2', '#2F374D', '#E7B453', '#F7D157'],
            rows: [
                '....................',
                '..1111111.1111111...',
                '.12222222122222221..',
                '.122221221322232221.',
                '.122222121422232221.',
                '.122222235223322221.',
                '.122222235232222221.',
                '.121122241322222221.',
                '.122212124342222221.',
                '.122221221322222221.',
                '.122222221422222221.',
                '.122222245332222221.',
                '.122212143323242221.',
                '.122221231422425221.',
                '.13222223.122222511.',
                '..1111111..1111111..',
                '.........4..........',
                '..4...4.....5.......',
                '...............5....',
                '.....4.......4......',
            ],
        },
    },
    role: 'playable',
    abilities: [
        onResolve((ctx) => {
            const targetId = plannedUnit(ctx);
            const target = targetId === undefined ? undefined : ctx.q.allUnits().find((unit) => unit.id === targetId);
            if (target?.cellId === undefined || !target.isToken)
                return;
            const ownerId = ctx.self.controllerId;
            ctx.ops.destroy(target.id);
            ctx.ops.drawCard(ownerId, 2);
        }),
    ],
    ui: {
        mechanics: ['token', 'death'],
        planning: {
            steps: { unit: { label: 'Выберите союзный токен' } },
        },
    },
});
//# sourceMappingURL=recycling.js.map